import IconArrowRightBlack from "components/EvtKit/icons/IconArrowRightBlack"
import TabsList from "components/EvtKit/tabs/TabsList"
import CreateProductTabTriggerButton from "./CreateProductTabTriggerButton"
import { memo } from "react"

import styled from "styled-components"
import { tabIds } from "pages/products/constants/defaultValues"

const ButtonsTriggersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

const TabsListContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

const Divider = styled.div`
  border: 1px solid ${(props) => props.theme.palette.disabled};
  width: 100%;
  margin-top: 8px;
`

interface CreateProductTabProps {
  isBenefitStepDisabled: boolean
  isUpdate?: boolean
}

const CreateProductTabList = (props: CreateProductTabProps) => {
  const { isBenefitStepDisabled, isUpdate } = props

  return (
    <TabsList>
      <TabsListContainer>
        <ButtonsTriggersContainer>
          <CreateProductTabTriggerButton
            label="Produto"
            numberLabel="1."
            triggerId={tabIds.product}
            isUpdate={isUpdate}
          />
          <IconArrowRightBlack />
          <CreateProductTabTriggerButton
            label="Benefícios"
            numberLabel="2."
            triggerId={tabIds.benefits}
            disabled={isBenefitStepDisabled}
            isUpdate={isUpdate}
          />
        </ButtonsTriggersContainer>
      </TabsListContainer>
      <Divider />
    </TabsList>
  )
}

export default memo(CreateProductTabList)
